// extracted by mini-css-extract-plugin
export default {"totalContainerItem":"totalCount_totalContainerItem__37iI9"};